export default __webpack_public_path__ + "static/media/EMP.7f3c4034.png";